import styled from 'styled-components'

import { helpers } from 'styles'

import { ButtonLink as DefaultButtonLink } from 'components/Buttons'

export const ButtonLink = styled(DefaultButtonLink)`
	margin: ${helpers.spacing.medium} 0;
`
